import DatePicker from "react-datepicker"
import { Controller, useWatch } from "react-hook-form"

const options = {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    // hour: '2-digit',
    // minute: '2-digit',
    // second: '2-digit',
    // hour12: true // For AM/PM format
};

const getNestedError = (errors, name) =>
    name?.split(".").reduce((acc, key) => (acc == null ? acc : acc[key]), errors);

const FormDate = ({ label, name, control, format = "yyyy-MM-dd", errors, min, onChangeHandler, showCurrentTZ = true }) => {

    const watchedValue = useWatch({ name, control });
    const fieldError = getNestedError(errors, name);

    const newYorkTime = watchedValue instanceof Date ? new Intl.DateTimeFormat('en-US', options).format(watchedValue) : null;


    return (
        <div style={{ padding: '0rem 0rem' }}>
            <label>{label} </label>
            {showCurrentTZ && <p> {`TZ: ${Intl.DateTimeFormat().resolvedOptions().timeZone}`}</p>}

            <Controller
                name={name}// Name of the field in your form data
                control={control} // The control object from useForm
                render={({ field }) => {
                    // console.log(new Date(field.value))
                    return (
                        <div style={{ paddingTop: '.6rem' }}>
                            <DatePicker
                                minDate={min}
                                className="date-picker"
                                isClearable={true}
                                selected={field.value} // Value from react-hook-form's state
                                onChange={(date) => { field.onChange(date); onChangeHandler?.() }} // Update react-hook-form's state on change
                                dateFormat={format} // Optional: specify date format
                            />
                        </div>
                    )
                }}
            />
            {fieldError?.message && <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{fieldError.message}</p>}

            <div style={{ padding: '1rem 0rem' }}>
                {newYorkTime && <p >{`${newYorkTime} - America/New_York`}</p>}
            </div>
        </div>
    )
}

export default FormDate